define('modules/base/models/uniquify.companies.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function (_, Backbone, BaseModel) {
    var UniquifyCompaniesModel = BaseModel.extend({
        base: 'uniquify/companies',
        baseService: 'nerds/v1'
    });
    return UniquifyCompaniesModel;
});
